<div class="flex flex-col gap-4 h-full min-h-0">
  <div class="flex items-center justify-between gap-3 shrink-0">
    <h3 class="m-0 text-lg font-bold text-midnight line-clamp-1">
      {{ data.title || 'Document preview' }}
    </h3>
    <div class="flex items-center gap-2 shrink-0">
      <button type="button" class="self-start" mat-dialog-close>
        <img src="assets/icons/close.svg" alt="Close" width="16" height="16" />
      </button>
    </div>
  </div>

  <div class="flex-1 min-h-0 overflow-hidden">
    @if (ready()) {
    <et-pdf-viewer-container
      [file]="data.file"
      [initialPage]="data.pageNumber"
      maxPageHeight="100%"
    ></et-pdf-viewer-container>
    }
  </div>
</div>
